export default __webpack_public_path__ + "static/media/1.4f56d1cf.png";